// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-largeOnWide-text-cebd73a1"};